import React, { useEffect, useState } from "react";
import "../../styles/Industries.css";
import { RiArrowRightSLine } from "react-icons/ri";
import SupplyChain_bg_img from "../../bg_images/I_supplyChain_bg_img.png";
import { MdArrowRightAlt } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { HiArrowNarrowRight } from "react-icons/hi";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";


const Servicecards = [
  {
    title: "Improving Supply Chain Visibility",
    text: " Gain real-time insights into inventory, shipments, and operations to proactively manage disruptions and optimize flow. ",
  },
  {
    title: " Enhancing Operational Efficiency ",
    text: " Streamline processes, automate tasks, and reduce manual errors with integrated IT systems and supply chain management software. ",
  },
  {
    title: "Optimizing Inventory Management ",
    text: " Implement intelligent systems to forecast demand, manage inventory levels effectively, and minimize holding costs. ",
  },
  {
    title: " Reducing Logistics Costs ",
    text: " Optimize transportation routes, warehouse operations, and delivery schedules with advanced logistic management software. ",
  },
  {
    title: " Improving Collaboration and Communication ",
    text: " Enable seamless communication and data sharing across your supply chain network with integrated IT solutions. ",
  },
];

const SupplyChain = () => {
  const navigate = useNavigate();



  
     const [currentIndex, setCurrentIndex] = useState(0);
        const [visibleServicecards, setVisibleServicecards] = useState(3);
      
        
        useEffect(() => {
          const updateVisibleServicecards = () => {
            if (window.innerWidth <= 768) {
              setVisibleServicecards(1); 
            } else {
              setVisibleServicecards(3); 
            }
          };
      
          updateVisibleServicecards();
          window.addEventListener("resize", updateVisibleServicecards);
          return () =>
            window.removeEventListener("resize", updateVisibleServicecards);
        }, []);
      
        const handleNext = () => {
          if (currentIndex + visibleServicecards < Servicecards.length) {
            setCurrentIndex(currentIndex + 1);
          }
        };
      
        const handlePrev = () => {
          if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
          }
        };
  


  return (
    <div className="Industries">
      <div
        className="I_sec1"
        style={{ backgroundImage: `url(${SupplyChain_bg_img})` }}
      >
        <h5>
          Industries <RiArrowRightSLine className="servrighticon" /> Supply
          Chain
        </h5>
        <h1> Optimize Your Supply Chain with Intelligent IT Solutions </h1>
        <p>
          We provide state-of-the-art  IT solutions that streamline operations,
          enhance visibility, and drive agility across your entire supply chain
          network.
        </p>
        <button
          onClick={() => navigate("/services/ApplicationDevelopment")}
          className="S_sec1_btn1"
        >
          Discover our solutions
          <HiArrowNarrowRight className="psec1arrow" />
        </button>
      </div>

      {/* Section 2 */}

      <div className="I_sec2">
        <h2>What we offer Our Supply Chain Customers</h2>
        <section className="I_sec2_cardsContainer">
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/sp_sec2_icon1.svg"
                alt=""
              />
              Integrated ERP Systems
            </h6>
            <p>
              Implement and optimize ERP systems for seamless supply chain
              management, enhancing visibility and control across all processes.
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/sp_sec2_icon2.svg"
                alt=""
              />
              Advanced Logistics Management Software
            </h6>
            <p>
              Utilize cutting-edge logistic management software to optimize
              transportation, warehousing, and delivery, reducing costs and
              improving efficiency.
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/sp_sec2_icon3.svg"
                alt=""
              />
              Real-Time Supply Chain Visibility
            </h6>
            <p>
              Implement solutions for end-to-end visibility across your supply
              chain, enabling proactive decision-making and risk mitigation.
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/sp_sec2_icon4.svg"
                alt=""
              />
              Cloud-Based Supply Chain Solutions
            </h6>
            <p>
              Leverage scalable and secure cloud platforms for enhanced
              collaboration, accessibility, and agility in your supply chain
              operations.
            </p>
          </section>
        </section>
        <button onClick={() => navigate("/contact")} className="I_sec2_btn1">
          Schedule a free consultation
          <HiArrowNarrowRight className="psec1arrow" />
        </button>
      </div>

      {/* Section 3 */}

      <div className="S_carousel-container">
          <h2 className="S_carousel-title">
            Solving the Key Challenges in Supply Chain
          </h2>
          <div className="S_carousel-wrapper">
            <button
              className="arrow left-arrow"
              onClick={handlePrev}
              disabled={currentIndex === 0}
            >
              <MdOutlineKeyboardArrowLeft className="S_rightArrow" />
            </button>
  
            <div className="S_carousel">
              <div
                className="S_carousel-track"
                style={{
                  transform: `translateX(-${
                    currentIndex * (100 / visibleServicecards)
                  }%)`,
                }}
              >
                {Servicecards.map((card, index) => (
                  <div className="S_carousel-card" key={index}>
                    <h3>{card.title}</h3>
                    <div className="underline"></div>
                    <p>{card.text}</p>
                  </div>
                ))}
              </div>
            </div>
  
            <button
              className="arrow right-arrow"
              onClick={handleNext}
              disabled={currentIndex + visibleServicecards >= Servicecards.length}
            >
              <MdOutlineKeyboardArrowRight className="S_rightArrow" />
            </button>
          </div>
        </div>

      {/* Section 4 */}

      <div className="I_sec4">
        <section className="I_sec4_left">
          <h1>Case Study</h1>
          <h6>
            Achieving Supply Chain Efficiency and Resilience with IT Solutions
          </h6>
          <p>
            A leading supply chain company was stuck in the past, relying on a
            legacy data platform that delayed critical business decisions. Their
            analytics system was 24 hours behind, creating a significant gap
            between operational needs and actionable insights. This lag affected
            everything from inventory management to demand forecasting, making
            it difficult to adapt to rapidly changing supply chain conditions.
          </p>
          {/* <p>
            Discover how we solved this challenge and built a lasting solution.
          </p> */}
        </section>
        <section className="I_sec4_right">
          <img
            className="I_sec4_img1"
            src="../images/I_supplyChain.png"
            alt="supplychain"
          />
        </section>
      </div>

      {/* Section 5  */}

      <div className="I_sec5">
        <section className="I_sec5_left">
          <h4>Ready to Transform Your Supply Chain with Technology? </h4>
          <p>
            Let's discuss how our IT solutions can optimize your supply chain,
            enhance your efficiency, and drive your business success.
          </p>
        </section>
        <section className="I_sec5_right">
          <button onClick={() => navigate("/contact")}>
            Request a Free Consultation
            <MdArrowRightAlt className="I_sec5_arrow_right" />
          </button>
        </section>
      </div>
    </div>
  );
};

export default SupplyChain;
